import { generateUUID } from 'utils/general';
import * as constants from './constants';

export function setUserInfo(userInfo) {
  return {
    type: constants.SET_USER_INFO,
    payload: userInfo,
  };
};

export function setShowPausedModal(state) {
  return {
    type: constants.SET_SHOW_PAUSED_MODAL,
    payload: state,
  };
}

export function setSubmissions(submissionData) {
  return {
    type: constants.SET_USER_SUBMISSIONS,
    payload: submissionData,
  };
};

export function pushSiteNotification(data) {
  return {
    type: constants.PUSH_SITE_NOTIFICATION,
    payload: { ...data, uuid: generateUUID() },
  };
};

export function removeSiteNotification(uuid) {
  return {
    type: constants.REMOVE_SITE_NOTIFICATION,
    payload: uuid,
  };
};

export function addNewSubmission(data) {
  return {
    type: constants.ADD_NEW_SUBMISSION,
    payload: data,
  };
};

export function updateSubmission(data) {
  return {
    type: constants.CHANGE_SUBMISSION,
    payload: data,
  };
};

export function switchUserRole() {
  return {
    type: constants.SWITCH_USER_ROLE,
  };
};

export const getCheckIn = () => {
  return {
    type: constants.GET_CHECKIN,
  };
};

export const getNotifications = ({ variables }) => {
  return {
    type: constants.GET_NOTIFICATIONS,
    payload: variables,
  };
};

export const getAddtNotifications = ({ variables }) => {
  return {
    type: constants.GET_ADDT_NOTIFICATIONS,
    payload: variables,
  };
};

export const markNotificationsRead = ({ variables }) => {
  return {
    type: constants.MARK_NOTIFICATIONS_READ,
    payload: variables,
  };
};

export const markNotificationRead = ({ variables }) => {
  return {
    type: constants.MARK_NOTIFICATION_READ,
    payload: variables,
  };
};

export const getTasks = () => {
  return {
    type: constants.GET_TASKS,
  };
};

export const getGeneralTasks = () => {
  return {
    type: constants.GET_GENERAL_TASKS,
  };
};

export const getProjectTasks = () => {
  return {
    type: constants.GET_PROJECT_TASKS,
  };
};

export const getLeadTasks = () => {
  return {
    type: constants.GET_LEAD_TASKS,
  };
};

export const getFocusTasks = () => {
  return {
    type: constants.GET_FOCUS_TASKS,
  };
};

export const addTaskAssignment = ({ variables }) => {
  return {
    type: constants.ADD_NEW_ASSIGNMENT,
    payload: variables,
  };
};

export const updateTaskAssignment = ({ variables }) => {
  return {
    type: constants.UPDATE_ASSIGNMENT,
    payload: variables,
  };
};

export const dropaskAssignment = ({ variables }) => {
  return {
    type: constants.DROP_ASSIGNMENT,
    payload: variables,
  };
};

export const createTaskComment = ({ variables }) => {
  return {
    type: constants.CREATE_NEW_COMMENT,
    payload: variables,
  };
};

export const updateTaskComment = ({ variables }) => {
  return {
    type: constants.UPDATE_COMMENT_DETAIL,
    payload: variables,
  };
};

export const deleteTaskComment = ({ variables }) => {
  return {
    type: constants.DELETE_COMMENT,
    payload: variables,
  };
};

export const createNotificationTask = ({ variables }) => {
  return {
    type: constants.CREATE_NEW_TASK,
    payload: variables,
  };
};

export const updateNotificationTask = ({ variables }) => {
  return {
    type: constants.UPDATE_TASK_DETAIL,
    payload: variables,
  };
};

export const deleteNotificationTask = ({ variables }) => {
  return {
    type: constants.DELETE_TASK,
    payload: variables,
  };
};

export const createTaskReminder = ({ variables, module, scope, isMyFocus }) => {
  return {
    type: constants.CREATE_TASK_REMINDER,
    payload: variables,
    module,
    scope,
    isMyFocus,
  };
};

export const updateTaskReminder = ({ variables, module, scope, isMyFocus }) => {
  return {
    type: constants.UPDATE_TASK_REMINDER,
    payload: variables,
    module,
    scope,
    isMyFocus,
  };
};

export const deleteTaskReminder = ({ variables, module, scope, isMyFocus }) => {
  return {
    type: constants.DELETE_TASK_REMINDER,
    payload: variables,
    module,
    scope,
    isMyFocus,
  };
};

export const reorderTask = ({ variables, params }) => {
  return {
    type: constants.REORDER_TASK,
    payload: variables,
    params,
  };
};

export function pushSiteError(data) {
  return {
    type: constants.PUSH_SITE_ERROR,
    payload: { ...data, uuid: generateUUID() },
  };
};

export function removeSiteError(uuid) {
  return {
    type: constants.REMOVE_SITE_ERROR,
    payload: uuid,
  };
};

export function pushAuthError(redirect) {
  return {
    type: constants.PUSH_AUTH_ERROR,
    payload: redirect,
  };
};

export function updateUserInfo(payload) {
  return {
    type: constants.UPDATE_USER_INFO,
    payload,
  };
}

export function updateUserInfoSuccess(payload) {
  return {
    type: constants.UPDATE_USER_INFO_SUCCESS,
    payload,
  };
}

export function updateUserInfoFail(payload) {
  return {
    type: constants.UPDATE_USER_INFO_FAIL,
    payload,
  };
}

export function getNotificationPreferences(payload) {
  return {
    type: constants.GET_NOTIFICATION_PREFERENCES,
    payload,
  };
}

export function getNotificationPreferencesSuccess(payload) {
  return {
    type: constants.GET_NOTIFICATION_PREFERENCES_SUCCESS,
    payload,
  };
}

export function getNotificationPreferencesFail(payload) {
  return {
    type: constants.GET_NOTIFICATION_PREFERENCES_FAIL,
    payload,
  };
}

export function saveNotificationPreferences(payload) {
  return {
    type: constants.SAVE_NOTIFICATION_PREFERENCE,
    payload,
  };
}

export function saveNotificationPreferencesSuccess(payload) {
  return {
    type: constants.SAVE_NOTIFICATION_PREFERENCE_SUCCESS,
    payload,
  };
}

export function saveNotificationPreferencesFail(payload) {
  return {
    type: constants.SAVE_NOTIFICATION_PREFERENCE_FAIL,
    payload,
  };
}

export function getUserInfo() {
  return {
    type: constants.GET_USER_INFO,
  };
};

export function getSingleTaskInfo(payload) {
  return {
    type: constants.FETCH_SINGLE_TASK,
    payload,
  };
}

export function getLinkedAccounts(payload) {
  return {
    type: constants.GET_LINKED_ACCOUNTS,
    payload,
  };
};

export function createIntegrationVCalGrant(payload) {
  return {
    type: constants.CREATE_INTEGRATION_VCAL_GRANT,
    payload,
  };
};

export function createIntegrationVCalGrantSuccess(payload) {
  return {
    type: constants.CREATE_INTEGRATION_VCAL_GRANT_SUCCESS,
    payload,
  };
};

export function createIntegrationVCalGrantFail(payload) {
  return {
    type: constants.CREATE_INTEGRATION_VCAL_GRANT_FAIL,
    payload,
  };
};

export function deleteIntegrationAccount(payload) {
  return {
    type: constants.DELETE_INTEGRATION_ACCOUNT,
    payload,
  };
};

export function deleteIntegrationAccountInit(payload) {
  return {
    type: constants.DELETE_INTEGRATION_ACCOUNT_INIT,
    payload,
  };
};

export function deleteIntegrationAccountSuccess(payload) {
  return {
    type: constants.DELETE_INTEGRATION_ACCOUNT_SUCCESS,
    payload,
  };
};

export function deleteIntegrationAccountFail(payload) {
  return {
    type: constants.DELETE_INTEGRATION_ACCOUNT_FAIL,
    payload,
  };
};

export function createLoginCalendar(payload) {
  return {
    type: constants.CREATE_LOGIN_CALENDAR,
    payload,
  };
};

export function createLoginCalendarSuccess(payload) {
  return {
    type: constants.CREATE_LOGIN_CALENDAR_SUCCESS,
    payload,
  };
};

export function createLoginCalendarFail(payload) {
  return {
    type: constants.CREATE_LOGIN_CALENDAR_FAIL,
    payload,
  };
};

export function deleteLoginCalendar(payload) {
  return {
    type: constants.DELETE_LOGIN_CALENDAR,
    payload,
  };
};

export function deleteLoginCalendarSuccess(payload) {
  return {
    type: constants.DELETE_LOGIN_CALENDAR_SUCCESS,
    payload,
  };
};

export function deleteLoginCalendarFail(payload) {
  return {
    type: constants.DELETE_LOGIN_CALENDAR_FAIL,
    payload,
  };
};

export function setIsForbidden() {
  return {
    type: constants.SET_IS_FORBIDDEN,
  };
};


/**
 * Converts array of color values into JSONString and updates user preferences saved colors.
 * @param {Array.<string>} colors
 * @returns
 */
export function updateLoginSavedColors(colors) {
  const transformedColors = colors.map(color => color.toLowerCase());
  // Remove duplicates.
  const uniqueColors = [...new Set(transformedColors)];
  // Normalize color values to always start with the hex.
  const validatedColors = uniqueColors.map(color => {
    if (color.charAt(0) !== '#') return `#${color}`;
    return color;
  });
  // Mutation expects a JSON string so convert to a string.
  const payload = JSON.stringify(validatedColors);
  return {
    type: constants.UPDATE_LOGIN_SAVED_COLORS,
    payload,
  };
};


export function updateLoginPreferences(prefs) {
  return {
    type: constants.UPDATE_LOGIN_PREFERENCES,
    payload: prefs,
  };
};
